import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_READ_KEYWORDS } from 'constants/urls';
import { KeywordFilters } from './types';

/**
 * Fetches a paginated, filterable list of keywords.
 * @param filters - Optional search/filter/pagination params
 * @returns The API response data (paginated keyword list)
 * @throws Re-throws any Axios error after logging
 */
const getKeywords = async (filters: KeywordFilters = {}) => {
  const payload = {
    Id: filters.Id || 0,
    SearchKeyword: filters.SearchKeyword || '',
    Page: filters.Page || 1,
    Take: filters.Take || 1000,
    ...filters,
  };

  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_READ_KEYWORDS}?payload=${JSON.stringify(payload)}`,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
        data: null,
      },
    );
    return data;
  } catch (error) {
    console.error('[getKeywords] Failed:', error);
    throw error;
  }
};

export default getKeywords;
